module.exports = __webpack_public_path__ + "static/banner-bg-464c9d1934f8c397b8f884ef5ee4d4af.jpg";